import { IOption } from '../_types'
import { getMultiLangText } from './getMultiLangText'

export function getDynamicPageLabel(
  item: IOption,
  locale: string,
  staticPageLabels: Record<string, string>
): string {
  const fromTitle = item.title ? getMultiLangText(item.title, locale, '') : ''
  if (fromTitle) return fromTitle

  return staticPageLabels[item.value] || item.label
}
